(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["prata-buy-now"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-buy-now')) {
    customElements.define('pp-buy-now', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const form = document.getElementById(this.dataset.form);
        const button = this.querySelector('button');
        const message = this.querySelector('p');
        if (!form) { button.disabled = true; return; }
        this.onVariant = (event) => {
          const available = Boolean(event.detail.variant?.available);
          button.disabled = !available || this.busy;
          button.textContent = available ? 'COMPRAR AGORA' : 'ESGOTADO';
        };
        this.productForm = form;
        form.addEventListener('variant:change', this.onVariant);
        button.addEventListener('click', async () => {
          if (this.busy || !form.reportValidity()) return;
          const data = new FormData(form);
          if (!data.get('id')) return;
          this.busy = true;
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          button.textContent = 'AGUARDE…';
          message.hidden = true;
          try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {method: 'POST', headers: {'Accept': 'application/json'}, body: data});
            const result = await response.json();
            if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Não foi possível adicionar esta peça. Confira a disponibilidade.');
            window.location.assign(window.Shopify.routes.root + 'checkout');
          } catch (error) {
            message.textContent = error.message || 'Não foi possível continuar. Confira sua sacola antes de tentar novamente.';
            message.hidden = false;
            this.busy = false;
            button.disabled = false;
            button.removeAttribute('aria-busy');
            button.textContent = 'COMPRAR AGORA';
          }
        });
      }
      disconnectedCallback() {
        this.productForm?.removeEventListener('variant:change', this.onVariant);
        this.ready = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["prata-commercial"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-commercial')) {
    customElements.define('pp-commercial', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = {signal:this.abort.signal};
        const connect = () => {
          const form = document.getElementById(this.dataset.form);
          form?.addEventListener('variant:change', (event) => {
            const variant = event.detail.variant;
            const badge = this.querySelector('[data-discount]');
            const percentage = variant && variant.compare_at_price > variant.price
              ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;
            badge.hidden = percentage <= 0;
            badge.textContent = '−' + percentage + '%';
            const conditions = this.querySelector('[data-conditions]');
            const content = variant && this.querySelector('[data-payment-variant="' + variant.id + '"]');
            conditions.replaceChildren(...(content ? [content.content.cloneNode(true)] : []));
          }, options);
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, {...options,once:true});
        else connect();
        const dialog = this.querySelector('dialog');
        const opener = this.querySelector('[data-open-payments]');
        opener?.addEventListener('click', () => dialog.showModal(), options);
        this.querySelector('[data-close-payments]')?.addEventListener('click', () => dialog.close(), options);
        dialog?.addEventListener('click', event => {
          const rect = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
        }, options);
        dialog?.addEventListener('close', () => opener.focus(), options);
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["prata-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-delivery')) {
    customElements.define('pp-delivery', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const form = this.querySelector('form');
        if (!form) return;
        this.rateRevision = 0;
        this.controller = new AbortController();
        const invalidate = () => {
          this.rateRevision++;
          this.querySelector('.pp-delivery__result')?.replaceChildren();
        };
        const listenerOptions = {signal:this.controller.signal};
        form.addEventListener('input', invalidate, listenerOptions);
        document.addEventListener('cart:change', invalidate, listenerOptions);
        document.addEventListener('cart:refresh', invalidate, listenerOptions);
        document.getElementById(this.dataset.productForm)?.addEventListener('variant:change', invalidate, listenerOptions);
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          const button = form.querySelector('button');
          const result = this.querySelector('.pp-delivery__result');
          const zip = form.elements.cep.value.replace(/\D/g, '');
          if (zip.length !== 8 || button.disabled) return;
          const revision = ++this.rateRevision;
          button.disabled = true;
          result.textContent = 'Consultando…';
          try {
            const root = window.Shopify.routes.root;
            const cartResponse = await fetch(root + 'cart.js');
            if (!cartResponse.ok) throw new Error();
            const cart = await cartResponse.json();
            const productForm = document.getElementById(this.dataset.productForm);
            const variant = new FormData(productForm).get('id');
            if (!cart.items.some(item => String(item.variant_id) === String(variant))) {
              result.textContent = 'Adicione esta peça à sacola e clique em CALCULAR novamente.';
              return;
            }
            const query = new URLSearchParams({'shipping_address[zip]': zip, 'shipping_address[country]': 'Brazil', 'shipping_address[province]': form.elements.province.value});
            const prepare = await fetch(root + 'cart/prepare_shipping_rates.json?' + query, {method: 'POST'});
            if (!prepare.ok) {
              const errors = await prepare.json();
              if (JSON.stringify(errors).match(/province|estado/i)) {
                form.elements.province.hidden = false;
                result.textContent = 'Selecione seu estado e clique em CALCULAR para consultar a entrega.';
                return;
              }
              throw new Error();
            }
            let data = null;
            for (let attempt = 0; attempt < 12; attempt++) {
              const response = await fetch(root + 'cart/async_shipping_rates.json?' + query);
              if (!response.ok) throw new Error();
              data = await response.json();
              if (data !== null) break;
              await new Promise(resolve => setTimeout(resolve, 700));
            }
            if (!data) throw new Error();
            if (revision !== this.rateRevision) return;
            const latestCartResponse = await fetch(root + 'cart.js');
            if (!latestCartResponse.ok) throw new Error();
            const latestCart = await latestCartResponse.json();
            const fingerprint = value => JSON.stringify([value.currency,value.total_price,value.items.map(item => [item.key,item.quantity,item.final_line_price])]);
            if (revision !== this.rateRevision || fingerprint(cart) !== fingerprint(latestCart)) {
              result.textContent = 'Sua sacola mudou. Calcule novamente para atualizar a entrega.';
              return;
            }
            result.replaceChildren();
            const rates = data.shipping_rates || [];
            if (!rates.length) {
              result.textContent = 'Nenhuma opção retornada para este CEP. Confira o endereço completo no checkout.';
              return;
            }
            if (rates.some(rate => rate.price !== null && rate.price !== undefined && String(rate.price).trim() !== '' && Number(rate.price) === 0)) {
              const badge = document.createElement('p');
              badge.className = 'pp-delivery__free';
              badge.textContent = 'FRETE GRÁTIS';
              result.append(badge);
            }
            rates.forEach(rate => {
              const line = document.createElement('p');
              const value = new Intl.NumberFormat('pt-BR', {style: 'currency', currency: rate.currency || cart.currency}).format(Number(rate.price));
              line.textContent = (rate.presentment_name || rate.name) + ' · ' + value;
              result.append(line);
            });
            const note = document.createElement('p');
            note.textContent = 'Opções da sacola atual. Confira o prazo e o endereço completo no checkout.';
            result.append(note);
          } catch {
            if (revision !== this.rateRevision) return;
            result.textContent = 'Não foi possível consultar por CEP. Confira as opções reais de entrega no checkout com seu endereço completo.';
          } finally {
            button.disabled = false;
          }
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
